var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["facets/category-facets-inner-mobile.j2"] = require( "facets/category-facets-inner-mobile.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-mobile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n\n<div class=\"o-modal c-facets s-facets-modal dom-mobile-facets js-modal-facets\" ";
if((lineno = 8, colno = 87, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.mobileFacetState.showFacets",runtime.contextOrFrameLookup(context, frame, "False")])) && !(lineno = 8, colno = 147, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.mobileFacetState.selectedFacetType"]))) {
output += "style=\"display: block;\"";
;
}
output += ">\n    ";
env.getTemplate("facets/category-facets-inner-mobile.j2", false, "category/templates/facets/category-facets-mobile.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-mobile.j2"] , dependencies)